<div class="input-group" [class]="classDate" >
  <input type="text" [id]="id" class="form-control">
  <button class="input-group-text" type="button" (click)="openPicker()">
    <i class="feather icon-calendar icon-md text-muted"></i>
  </button>
</div>
<!-- <ngb-datepicker #dp [minDate]="minDate" [maxDate]="maxDate" (navigate)="dateChange($event.next)">
</ngb-datepicker> -->
